import  { useEffect, useState } from "react";
import "./SixthReport.css";

const QTag = ({ q, a, impacts }) => (
  <div style={{display:'flex',flexWrap:'wrap',gap:'5px 10px',alignItems:'center',background:'#f0f4ff',border:'1px solid #c7d7fa',borderRadius:'6px',padding:'7px 12px',marginBottom:'12px',fontSize:'12px',lineHeight:1.5}}>
    <span style={{background:'#3b5bdb',color:'#fff',fontWeight:700,padding:'2px 8px',borderRadius:4,fontSize:'10px',whiteSpace:'nowrap'}}>📋 FORM QUESTION</span>
    <span style={{color:'#1e3a8a',fontStyle:'italic'}}>"{q}"</span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#047857',fontWeight:700}}>You answered: <strong>{a}</strong></span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#7c3aed',fontSize:'11px'}}>📊 Impacts: {impacts}</span>
  </div>
);

const SixthReport = ({ res }) => {
  const [costValue, setCostValue] = useState("");
  const [profitValue, setProfitValue] = useState("");
  const [financialValue, setFinancialValue] = useState("");
  const [priceValue, setPriceValue] = useState("");
  const [financingValue, setFinancingValue] = useState("");

  useEffect(() => {
    if (!res) return;

    setCostValue(res.cost || "");
    setProfitValue(res.profit || "");
    setFinancialValue(res.financial || "");
    setPriceValue(res.price || "");
    setFinancingValue(res.financingOptions || "");
  }, [res]);

  // Case-insensitive versions
  const costVal = (costValue || "").toLowerCase();
  const profitVal = (profitValue || "").toLowerCase();
  const financialVal = (financialValue || "").toLowerCase();
  const priceVal = (priceValue || "").toLowerCase();
  const financingVal = (financingValue || "").toLowerCase();

  // Remove symbols when displaying
  const cleanText = (str) =>
   str.replace(/^[%^*&]/, "")
// removes only first symbol

  const costContent =
    costVal === "%yes"
      ? "If the team is ready to bear prototype cost (5–20L), it shows strong conviction and financial backup — increasing feasibility and investor confidence."
      : "If the team is not financially ready, exploring grants, subsidies, partnerships, or incubator-funded prototype programs is recommended.";

  const profitContent =
    profitVal === "^yes"
      ? "If you believe in your idea and are ready to sustain operations for up to three years without immediate profit, it demonstrates strong conviction, leadership, and the ability to reach product–market fit — key qualities investors value."
      : "However, if belief or financial capacity is low, a lean model, grants, and early revenue generation strategies are recommended.";

  const financialContent =
    financialVal === "&yes"
      ? "Having additional income resources or backup plans ensures financial stability and builds investor confidence."
      : "If such resources are missing, alternate income streams and a lean cost model are suggested until financial stability improves.";

  const priceContent =
    priceVal === "*yes"
      ? "If product pricing matches customer affordability, it increases adoption, brand trust, and investor attraction."
      : "If the price exceeds customer capacity, introduce flexible pricing or optimize costs to increase affordability.";

  const financingContent =
    financingVal === "installment plans"
      ? "Investors love installment/subscription-based models — they provide predictable cash flow, scalability, and customer retention."
      : financingVal === "subsidies"
      ? "Subsidy-based models are strong for impact startups but may limit long-term scalability."
      : financingVal === "cash"
      ? "Cash-based models are great for early traction and survival — but may lack stability for large-scale investment."
      : "";


      const formatYesNo = (str) => {
  if (!str) return "";
  const cleaned = cleanText(str).toLowerCase();
  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
};


  return (
    <>
    <QTag
      q="Can your team fund the prototype cost? Can you sustain operations for 3 years without profit? What is your preferred financing model?"
      a={`Prototype cost ready: ${costVal === "%yes" ? "Yes" : "No"} · 3-yr sustainability: ${profitVal === "^yes" ? "Yes" : "No"} · Financing: ${cleanText(financingValue) || "—"}`}
      impacts="Financial feasibility score, runway length, investor confidence level, funding model attractiveness"
    />
    <div style={{ padding: "20px" }}>
      <div className="module5-container">
        <span className="corner top-left"></span>
        <span className="corner top-right"></span>
        <span className="corner bottom-left"></span>
        <span className="corner bottom-right"></span>

        <h3 className="module-title"> <span className="module-prefix">Module 5:</span>  Affordability</h3>

        {costValue && (
          <table className="sixth-module-table">
            <tbody>
              <tr>
                <td className="serial-cell">5 A</td>
                <td>{cleanText(costValue)}</td>
                <td>{costContent}</td>
              </tr>
            </tbody>
          </table>
        )}

        {profitValue && (
          <table className="sixth-module-table">
            <tbody>
              <tr>
                <td className="serial-cell">5 B</td>
                <td>{formatYesNo(profitValue)}</td>

                <td>{profitContent}</td>
              </tr>
            </tbody>
          </table>
        )}

        {financialValue && (
          <table className="sixth-module-table">
            <tbody>
              <tr>
                <td className="serial-cell">5 C</td>
                <td>{cleanText(financialValue)}</td>
                <td>{financialContent}</td>
              </tr>
            </tbody>
          </table>
        )}

        {priceValue && (
          <table className="sixth-module-table">
            <tbody>
              <tr>
                <td className="serial-cell">5 D</td>
                <td>{cleanText(priceValue)}</td>
                <td>{priceContent}</td>
              </tr>
            </tbody>
          </table>
        )}

        {financingValue && (
          <table className="sixth-module-table">
            <tbody>
              <tr>
                <td className="serial-cell">5 E</td>
                <td>{cleanText(financingValue)}</td>
                <td>{financingContent}</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
    </>
  );
};

export default SixthReport;
